// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".acca-toast-notification{border:1px solid transparent;-webkit-box-shadow:none;box-shadow:none;text-align:center;line-height:1.4;font-family:avenir,Helvetica,Arial,sans-serif;padding:1rem .5rem}.acca-toast-notification.Toastify__toast--success{background:#dcf0dc;color:#000;border-color:#8cc84b}.acca-toast-notification.Toastify__toast--error{background:#fe9898;color:#000;border-color:#f24137}", ""]);
// Exports
module.exports = exports;
